import React, { useState } from "react";
import "./Contact.css";
import { toast } from "react-toastify";

function Contact() {
  const [email, setEmail] = useState("");
  const [sujet, setSujet] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async () => {

    if (!email || !sujet || !message) {
        
        toast.error("Champs manquants !", {
            position: "top-left",
            autoClose: 1000, // Disparait après 3 secondes
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
        
        });
      return;
    }

    try {
      const response = await fetch('/backend/contact_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          sujet: sujet,
          message: "Message de "+email+" : "+message
        })
      });

      if (response.ok) {
        toast.success("Message envoyé !", {
            position: "top-left",
            autoClose: 1000, // Disparait après 3 secondes
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
        
        });
        setEmail("");
        setSujet("");
        setMessage("");
      } else {
        const text = await response.text();
        SendingError();
      }
    } catch (error) {
      console.error("Erreur:", error);
      SendingError();
    }
  };

  function SendingError() {
    toast.error("Erreur d'envoi !", {
        position: "top-left",
        autoClose: 1000, // Disparait après 3 secondes
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
    });
  }

  return (
    <div className="contactContainer">
      <div className="contact">
        <div className="contactMail">
          <h3>Contact</h3>
          <form>
          <input 
            type="email"
            placeholder="Ton adresse mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          </form>
        </div>
        <div className="contactContenu">
          <select
            value={sujet}
            onChange={(e) => setSujet(e.target.value)}
          >
            <option value="" disabled>Tu me contactes pour...</option>
            <option value="Commande">Une commande</option>
            <option value="Rencontre">Une rencontre</option>
            <option value="Partenariat">Un partenariat</option>
            <option value="Autre">Autre</option>
          </select>
          <textarea 
            className="contactMessage"
            placeholder="Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        <div className="contactBouton">
          <button onClick={handleSubmit}>Envoyer</button>
        </div>
      </div>
    </div>
  );
}

export default Contact;
